import React, { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';

const InventoryImportDetailPage = () => {
  const { orderId } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    // Redirect to create page with orderId parameter for editing
    if (orderId) {
      navigate(`/inventory-import/create/${orderId}`, { replace: true });
    } else {
      // If no orderId, redirect to create new order
      navigate('/inventory-import/create', { replace: true });
    }
  }, [orderId, navigate]);

  return null; // This component only handles redirection
};

export default InventoryImportDetailPage;